import { IRuleOptions, IValidationOptions, IValidationRule, RuleName } from "./Validator";

export class MaxLengthRule implements IValidationRule
{
    public rule: RuleName = 'MaxLength';
    private maxLength: number;
    private errorLabel: string;

    constructor(maxLength: number, validationOptions: IValidationOptions, ruleOptions: IRuleOptions = {})
    {
        this.maxLength = maxLength;
        this.errorLabel = ruleOptions.errorLabel ?? validationOptions.mustBeMaxLengthLabel ?? validationOptions.invalidFieldLabel;
    }

    public validate(value: string): string
    {
        if (value?.trim().length >  this.maxLength)
        {
            return '';
        }
        return this.errorLabel;
    }
}
